<template>
  <v-card :class="[{ 'sm-scroll': $vuetify.breakpoint.smAndDown }]">
    <div style="color: #002f6c" class="title font-weight-bold text-center">
      Datos Generales del Cliente
    </div>
    <v-row v-if="DatosCliente!==undefined" justify="start">
      <v-col cols="12" sm="12" lg="6" xl="6">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 8 : 2"
            :class="[{ 'on-hover': hover }, 'rounded-md', 'v-cardgrid', 'ma-2']"
          >
            <v-simple-table dense light>
              <tbody>
                <tr v-for="(value, key) in items[0]" :key="key">
                  <td
                    class="text-right black--text subtitle-2 font-weight-bold"
                  >
                    {{ key }}:
                  </td>
                  <td class="text-left bold--text subtitle-2">
                    {{ value }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-hover>
      </v-col>

      <v-col cols="12" sm="12" lg="6" xl="6">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 8 : 2"
            :class="[
              { 'on-hover': hover },
              'rounded-md',
              'v-cardgrid',
              'ma-2',
              'mb-5',
            ]"
          >
            <v-simple-table dense light>
              <tbody>
                <tr v-for="(value, key) in items[1]" :key="key">
                  <td
                    class="text-right black--text subtitle-2 font-weight-bold"
                  >
                    {{ key }}:
                  </td>
                  <td class="text-left bold--text subtitle-2">
                    {{ value }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 8 : 2"
            :class="[{ 'on-hover': hover }, 'rounded-md', 'v-cardgrid', 'ma-2']"
          >
            <v-simple-table dense light>
              <tbody>
                <tr v-for="(value, key) in items[2]" :key="key">
                  <td
                    class="text-right black--text subtitle-2 font-weight-bold"
                  >
                    {{ key }}:
                  </td>
                  <td class="text-left bold--text subtitle-2">
                    {{ value }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-hover>
      </v-col>

      <v-col cols="12" sm="12" lg="12" xl="12">
        <v-card class="rounded-md v-cardgrid ma-2 mb-6" tile>
          <v-card-subtitle
            class="text-left black--text subtitle-2 font-weight-bold"
          >
            DIRECCION:
          </v-card-subtitle>
          <v-row>
            <v-col cols="12" sm="12" lg="6" xl="6">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :elevation="hover ? 8 : 2"
                  :class="[{ 'on-hover': hover }, 'rounded-md', 'ma-2']"
                  tile
                >
                  <v-card-subtitle
                    class="text-left bold--text subtitle-2 font-weight-bold"
                  >
                    FISCAL:</v-card-subtitle
                  >
                  <v-card-text>{{ items[3][0] }}</v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="6" xl="6">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :elevation="hover ? 8 : 2"
                  :class="[{ 'on-hover': hover }, 'rounded-md', 'ma-2']"
                  tile
                >
                  <v-card-subtitle
                    class="text-left bold--text subtitle-2 font-weight-bold"
                  >
                    ENTREGA:</v-card-subtitle
                  >
                  <v-card-text>{{ items[3][1] }}</v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions("mod_cliente", ["GetDatosCliente"]),
    ...mapMutations("mod_cliente", ["set_DatosCliente"]),
    async getDatosCliente() {
      this.set_DatosCliente();
      await this.GetDatosCliente({
        cia: 1,
        cliente: this.Cliente.data.Codigo,
        rif: this.Cliente.data.Rif,
      });
    },
  },
  computed: {
    ...mapState(["Cliente", "simboloMoneda", "tipoMoneda"]),
    ...mapState("mod_cliente", ["DatosCliente"]),
    items() {
      const d = this.DatosCliente;
      let numeral = require("numeral");
      const LimiteCred = numeral(d.LimCred).format("0,0");
      const Ingreso = moment(d.Ingreso).format("DD/MM/YYYY");
      const Email = d.Email.includes(";")
        ? d.Email.split(";").join(", ")
        : d.Email;

      return [
        {
          Alias: d.xAlias,
          Representante: d.Representante,
          Telefonos: d.Telefonos,
          Fax: d.Fax,
          Ciudad: d.Ciudad,
          Estado: d.Estado,
          "Condicion Pago": d.CondPago,
          "Zona Venta": d.ZonaVen,
          "Zona Cobro": d.ZonaCob,
          "Limite Credito": LimiteCred,
          "Tipo Cliente": d.TipoCli,
        },
        {
          Rif: d.Rif,
          Ingreso: Ingreso,
          Distribuidor: d.Distrib,
          Grupo: d.Grupo,
          Email: Email,
        },
        {
          Activo: d.Activo ? "Si" : "No",
          Backorder: d.Backorder ? "Si" : "No",
          "Aplica Descuento Financiero": d.DescFinan ? "Si" : "No",
          "Contribuyente Especial": d.ContribEsp ? "Si" : "No",
          "Aplica Excepciones en Promociones": d.ExcepPromo ? "Si" : "No",
        },
        [d.DirecFiscal, d.DirecEntreg],
      ];
    },
  },
  created() {
    this.getDatosCliente();
  },
};
</script>

<style scoped>
.v-cardgrid {
  background-color: #ffffff !important;
  border: 1px solid #fe5000 !important;
  transition: opacity 0.4s ease-in-out;
  margin: 1px;
}
.sm-scroll {
  overflow-x: hidden;
  height: 550px;
}
</style>
